import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import seluxLogo from '../../../../icons/selux-logo';
import {luminaryOptions, baseProfileOptions} from '../../../sectionConfig';



@customElement('page-header')
export class PageHeader extends connect(store)(LitElement) {

	static styles = css`

	h1 {
		color: var(--color-black);
		font: var(--font-light);
		letter-spacing: 0.2px;
		line-height: 17px;
	}

	h1 span {
		font: var(--font-specsheet-print-title-bold);
	}

	.header-container {
		display: flex;
		margin-bottom: 20px;
		width: 98vw;
	}

	.flex-item.logo {
		display: table-cell;
		margin: 0;
		width: 15vw;
	}

	.flex-item.title {
		display: table-cell;
		padding-top: 25px;
		width: 85vw;
	}

	.flex-item.title h1 {
		max-width: 60vw;
		font-size: 14px;
		padding-bottom: 35px;
	}

	.flex-item.title.border h1 {
		border-bottom: 1px solid grey;
	}

	.logo {
		width: 78px;
	}
	`;

	static properties = {
		contentTitle: {type: String },
		introTitle: { type: String },
		labelChoice: { type: String },
		classTitle: { type: String },
	};

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
		this.contentTitle = this.getAttribute('content-title') || '';
		this.introTitle = this.getAttribute('intro-title') || '';
		this.labelChoice = this.getAttribute('label-choice') || '';
		this.classTitle = this.getAttribute('class-title') || '';
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
		this.decisions = state.decisions.data;
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
		this.translations = state.productData.translations;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.productData = state.productData.productData;
		this.lang = state.status.lang;
		this.projectName = this.lightProfile.project.projectName ?? '';
	}

	connectedCallback() {
		super.connectedCallback();
		this.contentTitle = this.getAttribute('content-title') || '';
		this.introTitle = this.getAttribute('intro-title') || '';
	  }

	render() {
		const s = this.state;
		const lmo = luminaryOptions.find( luminaryOption =>  luminaryOption.id === this.lightProfile.project.luminary);
		const bpo = baseProfileOptions.find(baseProfileOption => baseProfileOption.id === this.lightProfile.project.base);
		const profileLabel = bpo ? bpo.label[this.lang] : '';
		const prefixedLabel = html`<br>${msg('Circular light profile')}: ${profileLabel}`;
		const summary = html`${msg('Circular light profile')}: ${profileLabel}`;
		const summaryLabel = html`${summary} ${when(this.projectName !== '', () => html` ${msg('for')} ${this.projectName}`)}`;
		const lightLabel = lmo ? html`<br>${lmo.label[this.lang]}` : '';



		let chosenLabel = '';
		if (this.labelChoice === 'light') {
			chosenLabel = lightLabel;
		} else if (this.labelChoice === 'profile') {
			chosenLabel = prefixedLabel;
		} else if (this.labelChoice === 'summary') {
			chosenLabel = summaryLabel;
		}

		return html`
		<div class="header-container">
			<div class="flex-item title">
				<h1><span>${this.contentTitle}</span><br>
				${this.introTitle ? html`<span>${this.introTitle}</span><br />` : ''}
				${chosenLabel}
			</div>
			<div class="flex-item logo">
				<div class="logo">
					${seluxLogo}
				</div>
			</div>
		</div>
		`;
	}
}
